// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3br58","disabled":"FileBtn_disabled__1e1Zt","warn":"FileBtn_warn__35MzN","fade":"FileBtn_fade__Yu1mY"};